import Vue from 'vue'
import Vuex from 'vuex'

import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  theme: 'bubble',
  position: 'top-right',
  duration: 5000,
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    vendor: localStorage.getItem('vendor') || null,
    userData: {
      step:'',
      detectedVendor:'',
      selectedVendor:'',
      year: '',
      make: '',
      model: '',
      trim: '',
      vehicleStyle: '',
      carDetails: '',
      odometerReading: '',
      vin: '',
      selectedRepair: '',
      repairOfferAmount: '',
      cashBack: '',
      marketValue: '',
      dataCertainty: '',
      loanRequested: '',
      approvedLoanAmount: '',
      boundaryAmount: '',
      payment: 0,
      paymentFrequency: 3,
      paymentPeriod: '',
      numberOfPayments: 12,
      paymentTotal: 0,
      paymentFees: 0,
      loanApr: 0,
      newAPR:'',
      vendorToPay:'',
      firstPaymentDay:'',
      totalPayments:'',
      costOfFinancing:'',
      frequencyOfPayments:'',
      frequencyText:'',
      term: '',
      metric: 'km',
      vinFail: false,
      registered: false,
      title: false,
      sline: false,
      vendor:'',
      selectedProduct:'',
      productPrice:''
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js